<template>
  <zen-one :showuserinfo="false" :crumbs="crumbs" title="">
    <z-page title="Paparan Tangki Nitrogen" >
      <w-card bg-color="" class="">
          
            <div class="w-flex wrap smd-column" >
              <div class="grow ">

                <div class="fw-normal my1 fs-1"><b>Pembekal :</b><br>{{data.user}}&nbsp;</div>
                <div class="fw-normal my1 fs-1"><b>No Tangki :</b><br>{{data.no_tangki}}&nbsp;</div>
                <div class="fw-normal my1 fs-1"><b>Bilik :</b><br>{{data.ruangan}}&nbsp;</div>
                <div class="fw-normal my1 fs-1"><b>Rak :</b><br>{{data.rak}}&nbsp;</div>
                <div class="fw-normal my1 fs-1"><b>Level :</b><br>{{data.level}}&nbsp;</div>
                <div class="fw-normal my1 fs-1"><b>Slot :</b><br>{{data.slot}}&nbsp;</div>
              </div>
              <div class="mx2"></div>
              <div class="grow ">
                <div class="fw-normal my1 fs-1"><b>Jenis :</b><br>{{data.jenis_lebel}}&nbsp;</div>
                <div class="fw-normal my1 fs-1"><b>Tarikh :</b><br>{{data.tarikh}}&nbsp;</div>
                <div class="fw-normal my1 fs-1"><b>Kapasiti (Straw) :</b><br>{{data.kapasiti}}&nbsp;</div>
                <div class="fw-normal my1 fs-1"><b>Baki :</b><br>{{data.baki}}&nbsp;</div>
                <div class="fw-normal my1 fs-1"><b>Isipadu Nitrogen (ml) :</b><br>{{data.volume}}&nbsp;</div>
                <div class="fw-normal my1 fs-1"><b>Amaun :</b><br>{{data.amaun}}&nbsp;</div>
                <div class="fw-normal my1 fs-1"><b>Status :</b><br>{{data.lkp_status}}&nbsp;</div>
                <br>
                <!-- <w-flex class="flex justify-left">
                 <w-button  bg-color="warning"  :route="$route('premis.form',data.id)" class="be fs-2">
                    <w-icon xs class="mr2">fal fa-pencil</w-icon> Kemaskini 
                  </w-button>
                </w-flex> -->
                <br>
                
              </div>
            </div>
            
          <template v-if="data.jenis == 1">
            <w-tabs :items="tabs" :no-slider="false" active-class="primary" v-model="activeTab">
                <template #item-content.1>
                    <Semen :data="data" v-if="data.id > 0"/>
                </template>
                <template #item-content.2>
                    <SelTelur :data="data" v-if="data.id > 0"/>
                </template>
            </w-tabs>
          </template>
          <template v-else>
            <w-tabs :items="tabs" :no-slider="false" active-class="primary" v-model="activeTab">
               <template #item-content.1>
                <!-- <SelTelur :data="data" v-if="data.id > 0"/> -->
                <Embrio :data="data" v-if="data.id > 0"/>
              </template>
            </w-tabs>
          </template>
      </w-card>
    </z-page>
  </zen-one>
</template>

<script>
import { reactive } from 'vue'
import ZResource from '@/Modules/z-resource'
import Semen from './Show/Semen.vue';
import SelTelur from './Show/SelTelur.vue';
import Embrio from './Show/Embrio.vue';

export default {
  extends: ZResource,
  components: {
    Semen,
    SelTelur,
    Embrio
  },
  props: {
    id: [Array, Object, String],
  },
  data() {
    return {
      resourceurl: this.api_service + "tangki",
      crumbs: [
        { label: this.$page.props.app_name, route: '/home' },
        { label: 'Tangki Nitrogen', route: '/tangki' },
        { label: 'Papar', route: '/tangki/'+this.id },
      ],
      data : {id : 0},
      attahecment : [],
      slides : [],
      activeTab : 0,
      tabs: [
            
          ]
    }
  },
  methods: {
    getData()
    {
      this.$zcomm.get(this.api_service + 'tangki/show/'+this.id, {}).then(res => {
        this.data = res
        if(this.data.jenis == 1){
            this.tabs = [{ title: 'Semen', content: '' },
            { title: 'Sel Telur', content: '' }];
        }else{
          this.tabs = [
            { title: 'Embrio', content: '' }];
        }
      })
    },

    
   

  },
  watch: {

  },
  mounted() {
    this.getData();
    
  },
}
</script>
